import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-personality-dialog',
  templateUrl: './personality-dialog.component.html',
  styleUrls: ['./personality-dialog.component.scss']
})
export class PersonalityDialogComponent {

constructor(public dialogRef: MatDialogRef<PersonalityDialogComponent>) {
{}
}

   close(): void {
    this.dialogRef.close();
  }



}
